<ng-container *ngIf="save$ | async"></ng-container>

<div mat-dialog-title>
  <div i18n>{{ product.name }}</div>
  <button mat-button class="mat-icon-button" mat-dialog-close aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="no-padding overflow-hidden">
  <div class="h-full flex flex-row items-stretch" [cslOverlayLoader]="loading$">
    <mat-tab-group>
      <mat-tab i18n-label label="Данные">
        <cutting-product-data-form #productDataForm [product]="product"></cutting-product-data-form>
      </mat-tab>
      <mat-tab i18n-label label="Элементы">
        <cutting-product-elements
          class="min-h-50"
          fusePerfectScrollbar
          [processingMode]="product.processingMode"
          [elements]="originalElementList"
          (elementsChanged)="onElementsChanged.next($event)"
          [productId]="product.id"
          [multiplier]="product.count"
          [cuttingOptions]="cuttingOptions"
          #elementsList>
        </cutting-product-elements>
      </mat-tab>
    </mat-tab-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    i18n
    mat-raised-button
    class="mat-accent"
    (click)="saveAndClose()"
    [disabled]="productDataForm.productForm.invalid"
    >ОК</button
  >
  <button i18n mat-button mat-dialog-close>ОТМЕНА</button>
</mat-dialog-actions>
